import React from 'react';
import { Collapsible } from '../../components';

export function SelectListings({
  listings,
}) {
  return (
    <Collapsible
      trigger={`Select Listings (${listings.length})`}
      className="locked"
      open={false}
      triggerDisabled
    >
    </Collapsible>
  );
}
